import * as action from './action.js';
import reducer from './reducer.js';
import QuestionTempList from './question_temp_list';
import QuestionTML from './questionTML';


export { action, reducer,QuestionTempList, QuestionTML };


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/index.js